import type { WeeklyDungeonState, WeeklyDungeon } from "../types/games";
import type { WeeklyQuestCardView } from "../context/WeeklyQuestCardsContextBase";
export const getWeeklyLegendaryAvailability = ({
  cards = [],
  cardsLoaded = false,
  dungeons = [],
  dungeonsLoaded = false,
  dungeonState = null
}: { cards?: Partial<Pick<WeeklyQuestCardView, "rarity" | "opened" | "selected" | "completed">>[]; cardsLoaded?: boolean; dungeons?: Pick<WeeklyDungeon, "rarity">[]; dungeonsLoaded?: boolean; dungeonState?: WeeklyDungeonState | null } = {}) => {
  // Closed cards deliberately keep their rarity secret. Highlight the
  // navigation only after a legendary card has actually been revealed.
  const card = Boolean(
    cardsLoaded &&
    cards.some((item) =>
      item?.rarity === "legendary" &&
      (item.opened === true || item.selected === true || item.completed === true)
    )
  );
  const dungeon = Boolean(
    dungeonsLoaded &&
    (
      dungeonState?.legendaryDropped === true ||
      dungeons.some((item) => item?.rarity === "legendary")
    )
  );

  return {
    card,
    dungeon,
    any: card || dungeon
  };
};
